import { SeasonLink as Link } from "../Seasons/SeasonLink";
import { SeasonBar } from "../Seasons/SeasonBar";
import { useAuth } from "../../context/AuthContext";
import styles from "./PublicHeader.module.css";

export function PublicHeader({ sectionLabel, accountPath = "/profile", className = "", children }) {
  const { isAuthenticated } = useAuth();
  return (
    <header className={`${styles.header} ${className}`}>
      <Link to="/" className={styles.brand} aria-label="ЮФУ.Про — главная">
        ЮФУ.Про{sectionLabel && <span>{sectionLabel}</span>}
      </Link>
      <SeasonBar compact />
      <nav className={styles.links} aria-label="Навигация по платформе">
        {children}
        <Link to={isAuthenticated ? accountPath : "/login"} className={styles.account}>
          {isAuthenticated ? "Личный кабинет" : "Войти в кабинет"}
          <span aria-hidden="true">↗</span>
        </Link>
      </nav>
    </header>
  );
}
